<template>
  <section class="earning-deduction" data-testid="earning-deduction">
    <bg-grid>
      <bg-grid-item :col="12" class="mb-0">
        <filters
          :filter-values="filterValues"
          :options="filterOptions"
          @go-to-add-page="
            $router.push({ name: 'other-transaction.deduction.add' })
          "
          @on-filter-change="onFilterChange"
        />
      </bg-grid-item>

      <bg-grid-item :col="12">
        <expandable-deduction-table :loading="isLoading.initial" />

        <div class="ta-c">
          <bg-skeleton
            v-if="isLoading.initial"
            width="200px"
            height="32px"
            class="m-middle"
            data-testid="loader"
          />
          <template v-else>
            <bg-pagination
              v-if="pagination.totalPagination > 1"
              v-model="pagination.page"
              :page-total="pagination.totalPagination"
              data-testid="pagination"
            />
          </template>
        </div>
      </bg-grid-item>
    </bg-grid>
  </section>
</template>

<script>
import {
  BgGrid,
  BgGridItem,
  BgPagination,
  BgSkeleton,
} from 'bangul-vue';
import filterMixin from '../_mixins/filterMixin.js';

export default {
  name: 'EarningDeduction',

  components: {
    BgGrid,
    BgGridItem,
    BgPagination,
    BgSkeleton,
    ExpandableDeductionTable: () =>
      import('./_components/ExpandableDeductionTable'),
    Filters: () => import('@admin_pages/OtherTransaction/_components/Filters'),
  },

  mixins: [ filterMixin ],

  data() {
    return {
      isLoading: {
        initial: true,
      },

      pagination: {
        page: 1,
        totalPagination: 10,
      },
    };
  },

  async created() {
    this.isLoading.initial = true;
    this.isLoading.initial = false;
  },
};
</script>
